var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlickProducts',{attrs:{"block":_vm.block,"numeration":true,"showTitle":(_vm.position !== 0),"showPromoLabel":(_vm.position !== 0)}})
}
var staticRenderFns = []

export { render, staticRenderFns }